export default __webpack_public_path__ + "static/media/img1.b1094a2d.PNG";